(() => {

  function initEgyptGlassStickyCart() {

    if (window.innerWidth > 749) return;


    const productInfo =
      document.querySelector('.product__info-container');

    if (!productInfo) return;


    if (
      document.querySelector(
        '[data-eg-sticky-cart]'
      )
    ) {
      return;
    }


    const productForm =
      productInfo.querySelector(
        'product-form form, form[action*="/cart/add"]'
      );

    if (!productForm) return;


    const originalAddButton =
      productForm.querySelector(
        '[name="add"]'
      );

    if (!originalAddButton) return;


    const sticky =
      document.createElement('div');


    sticky.className =
      'eg-sticky-cart';

    sticky.setAttribute(
      'data-eg-sticky-cart',
      ''
    );


    sticky.innerHTML = `

      <div class="eg-sticky-cart__info">

        <div
          class="eg-sticky-cart__price"
          data-eg-sticky-price
        >
        </div>

        <div
          class="eg-sticky-cart__variant"
          data-eg-sticky-variant
        >
        </div>

      </div>


      <button
        type="button"
        class="eg-sticky-cart__button"
        data-eg-sticky-add
      >
        カートに追加
      </button>

    `;


    document.body.appendChild(sticky);


    const stickyPrice =
      sticky.querySelector(
        '[data-eg-sticky-price]'
      );


    const stickyVariant =
      sticky.querySelector(
        '[data-eg-sticky-variant]'
      );


    const stickyButton =
      sticky.querySelector(
        '[data-eg-sticky-add]'
      );


    function getCurrentPrice() {

      const priceContainer =
        productInfo.querySelector(
          '[id^="price-"], .price'
        );


      if (!priceContainer) {
        return '';
      }


      const salePrice =
        priceContainer.querySelector(
          '.price__sale .price-item--sale'
        );


      if (
        salePrice &&
        salePrice.textContent.trim()
      ) {
        return salePrice.textContent.trim();
      }


      const regularPrice =
        priceContainer.querySelector(
          '.price__regular .price-item--regular'
        );


      if (
        regularPrice &&
        regularPrice.textContent.trim()
      ) {
        return regularPrice.textContent.trim();
      }


      const fallbackPrice =
        priceContainer.querySelector(
          '.price-item'
        );


      return fallbackPrice
        ? fallbackPrice.textContent.trim()
        : '';

    }


    function getSelectedVariantText() {

      const picker =
        productInfo.querySelector(
          '.eg-variant-picker, variant-selects'
        );


      if (!picker) return '';


      const selections = [];


      picker
        .querySelectorAll(
          '.product-form__input'
        )
        .forEach((group) => {


          const radio =
            group.querySelector(
              'input[type="radio"]:checked'
            );


          if (radio) {

            selections.push(
              radio.value
            );

            return;
          }


          const select =
            group.querySelector('select');


          if (
            select &&
            select.value
          ) {

            selections.push(
              select.value
            );

          }

        });


      return selections.join(' / ');

    }


    function updateStickyCart() {

      stickyPrice.textContent =
        getCurrentPrice();


      stickyVariant.textContent =
        getSelectedVariantText();


      const disabled =
        originalAddButton.disabled ||
        originalAddButton.getAttribute(
          'aria-disabled'
        ) === 'true';


      stickyButton.disabled =
        disabled;


      if (disabled) {

        stickyButton.textContent =
          '売り切れ';

      } else {

        stickyButton.textContent =
          'カートに追加';

      }

    }


    stickyButton.addEventListener(
      'click',
      () => {

        if (stickyButton.disabled) {
          return;
        }


        originalAddButton.click();

      }
    );


    productInfo.addEventListener(
      'change',
      () => {

        window.setTimeout(
          updateStickyCart,
          50
        );

      }
    );


    const observer =
      new MutationObserver(
        updateStickyCart
      );


    observer.observe(
      productInfo,
      {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      }
    );


    function updateVisibility() {

      const rect =
        originalAddButton.getBoundingClientRect();


      const originalButtonVisible =
        rect.top < window.innerHeight &&
        rect.bottom > 0;


      if (originalButtonVisible) {

        sticky.classList.remove(
          'is-visible'
        );

      } else {

        sticky.classList.add(
          'is-visible'
        );

      }

    }


    window.addEventListener(
      'scroll',
      updateVisibility,
      {
        passive: true
      }
    );


    window.addEventListener(
      'resize',
      updateVisibility
    );


    updateStickyCart();

    updateVisibility();

  }


  document.addEventListener(
    'DOMContentLoaded',
    initEgyptGlassStickyCart
  );


  document.addEventListener(
    'shopify:section:load',
    initEgyptGlassStickyCart
  );

})();